module.exports = __webpack_public_path__ + "static/media/iconfinder_233_Node_Js_logo_4375017.c675a4b6.svg";